import { Node } from "reactflow";
import { GAP_BETWEEN_NODES } from "@zapier/canvas-constants";
import { getAbsoluteNodePosition, getCenteredYPosition } from "./index";
import { NodeType } from "../types";

type Params = {
  newNode: Node;
  nodes: Node[];
  isPathNode: boolean;
  sourceNode?: Node;
  targetNode?: Node;
};

/** Snap to incoming / outgoing node */
export function snapToAdjacentNode({
  newNode,
  nodes,
  isPathNode,
  sourceNode,
  targetNode,
}: Params) {
  if (!sourceNode && !targetNode) return newNode;

  const incomerNode = sourceNode;
  const outgoerNode = targetNode;

  // Determine if newNode has a parent
  const hasParent = Boolean(newNode.parentId);

  if (incomerNode) {
    // When snapping to a zap step, its position is relative to the zap node, so we need to convert to absolute position
    // But when inside a group node, don't use absolute position since child node positions are relative to parent node
    const incomerPosition = hasParent
      ? incomerNode.position
      : getAbsoluteNodePosition(incomerNode, nodes);
    newNode.position.x = incomerPosition.x + GAP_BETWEEN_NODES;
    newNode.position.y = getCenteredYPosition({
      nodePosition: incomerPosition,
      nodeType: incomerNode.type as NodeType,
      isPathNode: isPathNode,
    });
  } else if (outgoerNode) {
    const outgoerPosition = hasParent
      ? outgoerNode.position
      : getAbsoluteNodePosition(outgoerNode, nodes);
    const gap = isPathNode ? GAP_BETWEEN_NODES * 2 : GAP_BETWEEN_NODES;
    newNode.position.x = outgoerPosition.x - gap;
    newNode.position.y = getCenteredYPosition({
      nodePosition: outgoerPosition,
      nodeType: outgoerNode.type as NodeType,
      isPathNode: isPathNode,
    });
  }

  return newNode;
}
